import MainLayout from '@/components/layout/MainLayout.vue';
import { required, email } from 'vuelidate/lib/validators';
import axios from "axios";

export default {
    name: "ForgetPassword",

    components: {
        MainLayout
    },

    data() {
        return {
            user_type: '',
            email: '',
            mail_msg: '',
            submitted: false
        }
    },

    validations: {
        email: {
            required,
            email
        },
        user_type: {
            required
        }
    },

    methods: {
        handleSubmit() {
            this.submitted = true
            if (this.$v.invalid) {
                return;
            }
            this.sendResetMail()
        },
        
        sendResetMail() {
            var request = {
                email: this.email,
                user_type: this.user_type
            }
            axios.post("request", request)
                .then((response) => {
                    this.email = ''
                    this.submitted = false
                    if (response.data.status == 1) {
                        this.$notification.success("စကားဝှက် ပြောင်းရန် အီးမေးလ် ပို့ထားပါသည်", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else {
                        this.$notification.error("အီးမေးလ် မရှိပါ", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.$notification.error("Facebook Account ဖြင့် Login ဝင်ထားပါသဖြင့် Password Reset လုပ်ခွင့်မပေးထားပါ။", {
                            timer: 5,
                            position: "bottomCenter"
                        });
                    }
                });
        }
    }
}
